<template>
  <div>
    <form novalidate class="md-layout" @submit.prevent="validate">
      <md-card class="no-shadow md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title">Create an new Form</div>
        </md-card-header>

        <md-card-content>
          <md-field :class="getValidationClass('name')">
            <label for="name">Form Name</label>
            <md-input type="name" name="name" id="name" autocomplete="name" v-model="form.name" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.name.required">The form name is required</span>
          </md-field>

          <error-container :error="error"></error-container>

        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button type="submit" class="md-raised md-primary" :disabled="sending">Create</md-button>
        </md-card-actions>
      </md-card>

      <md-snackbar :md-active.sync="isSaved">The form {{ lastUser }} was saved with success!</md-snackbar>
    </form>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import ErrorFactory from '../../models/ErrorFactory'
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'
export default {
  name: 'FormCreateForm',
  mixins: [validationMixin],
  components: {
    ErrorContainer
  },
  data: () => ({
    form: {
      name: null
    },
    isSaved: false,
    sending: false,
    lastUser: null,
    error: null,
    errorFactory: new ErrorFactory()
  }),
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  computed: {
    axios () {
      return this.$store.getters['axios']
    },
    base_url () {
      return this.$store.getters['base_url']
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.email = null
      this.form.password = null
    },
    async send () {
      this.sending = true
      try {
        const { data } = await this.axios.post(this.base_url + '/forms', {
          name: this.form.name
        })

        if (!data || !data.token) {
          throw new Error()
        }

        await this.$store.dispatch('fetchForms')

        this.$router.push('/forms/' + data.id)
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Signup failed!')
      } finally {
        this.sending = false
      }
    },
    validate () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.send()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .no-shadow  {
    box-shadow: none;
  }
  .md-title {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/FormCreateForm.vue